<script>
  import { dndzone } from 'svelte-dnd-action'
  import { transformDraggedRow } from '../lib/table_drag.js'

  let {
    items = [],
    loading = false,
    dragEnabled = false,
    emptyMessage = 'No records found.',
    onreorder,
    skeletonRows = 5,
    header,
    row,
    empty
  } = $props()

  let localItems = $state(items)

  $effect(() => {
    localItems = items
  })

  let tbodyEl = $state(null)

  const handleConsider = (event) => {
    localItems = event.detail.items
  }

  const handleFinalize = (event) => {
    localItems = event.detail.items
    onreorder?.(localItems)
  }
</script>

<div class="overflow-x-auto">
  <table class="table">
    <thead>
      {@render header?.()}
    </thead>
    <tbody
      bind:this={tbodyEl}
      use:dndzone={{ items: localItems, dragDisabled: !dragEnabled, transformDraggedElement: transformDraggedRow(() => tbodyEl) }}
      onconsider={handleConsider}
      onfinalize={handleFinalize}
    >
      {#if loading}
        {#each Array(skeletonRows) as _, index (index)}
          <tr>
            <td colspan="100%"><div class="skeleton h-4 w-full"></div></td>
          </tr>
        {/each}
      {:else if localItems.length === 0}
        {#if empty}
          {@render empty()}
        {:else}
          <tr>
            <td colspan="100%" class="text-center text-base-content/60 py-6">{emptyMessage}</td>
          </tr>
        {/if}
      {:else}
        {#each localItems as item, index (item.id)}
          {@render row?.(item, index)}
        {/each}
      {/if}
    </tbody>
  </table>
</div>
